<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- <h1>优惠详情</h1> -->
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label-width
                          prop="tid"
                          label="订单号">
              <el-input v-model="form.tid"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="oid"
                          label="子订单号">
              <el-input v-model="form.oid"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="promotion_name"
                          label="优惠信息名">
              <el-input v-model="form.promotion_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="discount"
                          label="优惠金额">
              <!-- <el-input v-model="form.discount"></el-input> -->
              <number-range v-model="form.discount"></number-range>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="promotion_desc"
                          label="优惠描述">
              <el-input v-model="form.promotion_desc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platform_from"
                          label="平台">
              <el-select clearable
                         v-model="form.platform_from"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in tradefrom"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="searchAreaStatus">
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->

    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column align="center"
                       header-align="center"
                       prop="tid"
                       label="订单号"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="oid"
                       label="子订单号"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="promotion_name"
                       label="优惠信息名"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="discount"
                       label="优惠金额"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="promotion_desc"
                       label="优惠描述"></el-table-column>
      <!-- <el-table-column align="center" header-aligin="center" prop="trade_from" label="平台"></el-table-column> -->
      <el-table-column align="center"
                       header-aligin="center"
                       prop="platform_from"
                       label="平台"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'

import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'

export default {
  mixins: [ActionLine, SearchMixin, handleExport],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.loading = true
      let { data, err } = await this.axiosApi(
        Desc.promotionList_api,
        this.queryPrdlists
      )
      // console.log("data", data);
      this.loading = false
      this.tableData = data.data.data.data
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/promotion/index.vue